<div #sliderWrapper>
  <ngx-slider (userChangeEnd)="onChangedValue($event)" *ngIf="isVisible" [(value)]="value"
              [options]="options"></ngx-slider>
</div>
